import APIRequest from '@/api'
import { ref } from 'vue'
import { useAuthStore } from '@/stores/login'
import { updateUserInfo } from './userInfo'
import { useRoute } from 'vue-router'
import router from '../router'

const loginInitiated = ref(false)

export async function processWxworkJumpData(
  url: string,
  setAppId: Function,
  setBusinessWechatCode: Function,
  setBusinessWechatType: Function,
  setJumpName: Function,
  setJumpType: Function,
  setJumpModuleId: Function,
  setCustomTemplateId: Function
) {
  const urlParams = new URLSearchParams(url.split('?')[1])
  // console.log(urlParams, '1111111')
  const code = urlParams.get('code')
  const state = urlParams.get('state')
  const appId = urlParams.get('appId')
  // console.log(code)
  // console.log(state)
  // console.log(appId)

  if (appId) {
    setAppId(appId)
  }

  if (state && code) {
    setBusinessWechatCode(code)
    const [wechatType] = state.split('_')[0].split('#')[0].split('/')
    const [jumpName] = state.split('_')[1].split('#')[0].split('/')

    const jumpModuleId = urlParams.get('jumpModuleId')
    const jumpType = urlParams.get('jumpType')
    const customTemplateId = urlParams.get('customTemplateId') || ''

    const authStore = useAuthStore()
    authStore.setAccessToken('')
    localStorage.removeItem('sandsTalkToken')
    if (jumpType && jumpModuleId && !loginInitiated.value) {
      setJumpType(jumpType)
      setJumpModuleId(jumpModuleId)
      setCustomTemplateId(customTemplateId)
      await qywechatLogin()
      loginInitiated.value = true
    }

    if (wechatType && jumpName && !loginInitiated.value) {
      setBusinessWechatType(wechatType)
      setJumpName(jumpName)
      await qywechatLogin()
      loginInitiated.value = true
    }
  }
}

export const qywechatLogin = async () => {
  const { wxworkCode, appId, wxworkJumpType, wxworkJumpModuleId, jumpName, customTemplateId } = useAuthStore()
  const route = useRoute()
  const res = await APIRequest.User.accountLogin({
    grant_type: 'social',
    socialType: 'wxwork',
    code: wxworkCode,
    appId: appId
  })
  if (res.code === 1) {
    const authStore = useAuthStore()
    const token = res.data.access_token
    authStore.setAccessToken(token)
    localStorage.setItem('sandsTalkToken', token)
    localStorage.setItem('sandsTalkTenantId', res.data.tenantId || '1000');
    await updateUserInfo()
    if (wxworkJumpType && wxworkJumpModuleId) {
      wexinJump(
        wxworkJumpType,
        wxworkJumpModuleId,
        customTemplateId || ''
      )
    } else {
      if (jumpName && jumpName !== '') {
        feishuJump(jumpName)
      } else {
        router.replace(decodeURIComponent(decodeURIComponent((route.query.redirect || '/') as string)))
      }
    }
  }
}

export const feishuJump = (jumpName: string) => {
  switch (jumpName) {
    case 'home':
      router.replace('/')
      break
    case 'studyTask':
      router.replace('/task')
      break
    case 'community':
      router.replace('/community')
      break
    case '':
      router.replace('/')
      break
  }
}

export const wexinJump = (jumpType: string, jumpModuleId: any, customTemplateId: string) => {
  // 100 资讯
  // 202 课程
  // 300 考试
  // 400 调查
  // 500 项目列表
  // 600 CEO
  // 700 直播
  // 803 贴子
  // 1200 积分
  // 消息推送：1300 自定义消息 1301 自定义链接
  // 1400 practise
  // 1500 讲师创建 消息推送
  // 1600 面授 消息推送
  // 1700 培训确认单 消息推送

  switch (jumpType) {
    case '4':
    case '100':
    case '101':
    case '1300':
    case '1301':
      if (jumpType === '101') {
        if (jumpModuleId) {
          router.replace({
            path: `/broadcastDetail/${jumpModuleId}?topId=${customTemplateId}`,
            query: { jumpType: jumpType }
          })
        } else {
          router.replace({
            path: `/broadcastDetail/${jumpModuleId}`,
            query: { jumpType: jumpType }
          })
        }
      } else {
        router.replace({
          path: `/broadcastDetail/${jumpModuleId}`,
          query: { jumpType: jumpType }
        })
      }
      // window.location.replace(`${stsJumpUrl.value}broadcastDetail/${jumpModuleId}?jumpType=${jumpType}`)
      break
    case '201':
      // window.location.replace(
      //   `${stsJumpUrl.value}courseDetail?id=${jumpModuleId}&courseId=&courseType=course&endingType=0&channel=0`
      // )
      router.replace({
        path: '/courseDetail',
        query: { id: jumpModuleId, courseId: '', courseType: 'course', endingType: 0, channel: 0 }
      })
      break
    case '203':
      router.replace({
        path: '/courseDetail',
        query: {
          id: jumpModuleId,
          topId: customTemplateId,
          courseId: '',
          courseType: 'course',
          endingType: 0,
          channel: 0
        }
      })
      break
    case '204':
      router.replace({
        path: '/courseDetail',
        query: {
          id: jumpModuleId,
          topId: customTemplateId,
          courseId: '',
          courseType: 'courseWare',
          endingType: 0,
          channel: 0
        }
      })
      break
    case '18':
    case '200':
    case '202':
      // window.location.replace(`${stsJumpUrl.value}courseDetail?id=${jumpModuleId}&courseType=courseWare`)
      router.replace({ path: '/courseDetail', query: { id: jumpModuleId, courseType: 'courseWare' } })
      break
    case '6':
    case '300':
    case '301':
      // window.location.replace(`${stsJumpUrl.value}examInfo?examId=${jumpModuleId}`)
      router.replace({ path: '/examInfo', query: { examId: jumpModuleId } })
      break
    case '7':
    case '400':
      // window.location.replace(`${stsJumpUrl.value}surveyInfo?investigationId=${jumpModuleId}`)
      router.replace({ path: '/surveyInfo', query: { investigationId: jumpModuleId } })
      break
    case '5':
    case '500':
      // window.location.replace(`${stsJumpUrl.value}trainingDetail?id=${jumpModuleId}`)
      router.replace({ path: '/trainingDetail', query: { id: jumpModuleId } })
      break
    case '600':
      // window.location.replace(`${stsJumpUrl.value}CeoDetail?id=${jumpModuleId}`)
      router.replace({ path: '/CeoDetail', query: { id: jumpModuleId } })
      break
    case '700':
      // window.location.replace(`${stsJumpUrl.value}liveStreamTrans?id=${jumpModuleId}`)
      router.replace({ path: '/liveStreamTrans', query: { id: jumpModuleId } })
      break
    case '802':
      if (jumpModuleId) {
        router.replace({
          path: '/comDetailLevel',
          query: { id: jumpModuleId, topId: customTemplateId }
        })
      } else {
        router.replace({ path: '/comDetailLevel', query: { id: jumpModuleId } })
      }
      break
    case '803':
      if (jumpModuleId) {
        router.replace({
          path: '/comDetailLevel',
          query: { id: jumpModuleId, topId: customTemplateId }
        })
      } else {
        router.replace({ path: '/comDetailLevel', query: { id: jumpModuleId } })
      }
      break
    case '805':
      router.replace({
        path: '/rollVideo',
        query: { sortType: 0, id: jumpModuleId, topId: customTemplateId }
      })
      break
    case '806':
      router.replace({
        path: '/rollVideo',
        query: { sortType: 0, id: jumpModuleId, topId: customTemplateId }
      })
      break
    case '1200':
      // window.location.replace(`${stsJumpUrl.value}integral`)
      router.replace({ path: '/integral' })
      break
    // 证书
    case '1202':
      // const objParams = JSON.parse(jumpModuleId)
      router.replace({
        path: '/certificateDetail',
        query: { id: jumpModuleId }
      })
      break
    case '1101':
      // window.location.replace(`${stsJumpUrl.value}applyDetail?id=${jumpModuleId}`)
      router.replace({ path: '/applyDetail', query: { id: jumpModuleId } })
      break
    case '1400':
      router.replace({ path: '/examPractiseInfo', query: { practiseId: jumpModuleId } })
      break
    case '1500':
      router.replace({ path: '/lecturerDetail', query: { lecturerId: jumpModuleId } })
      break
    case '1501':
      // 面授
      router.replace({ path: '/teachManage/TeachDetail', query: { bizId: jumpModuleId } })
      break
    case '1502':
      // 直播
      router.replace({ path: '/teachManage/TeachManageLive', query: { id: jumpModuleId } })
      break
    case '1503':
      // 员工作业批阅
      router.replace({
        path: '/teachManage/HomeWorkCriticism',
        query: { submitRecordId: jumpModuleId, reviewStatus: 1, messageType: 'message' }
      })
      break
    case '1504':
      // 员工考试批阅
      router.replace({ path: '/teachManage/examReview', query: { examId: jumpModuleId } })
      break
    case '1505':
      // 作业批阅
      router.replace({ path: '/teachManage/HomeWorkDetail', query: { bizId: jumpModuleId, bizType: 2402 } })
      break
    case '1506':
      // 考试批阅
      router.replace({ path: '/teachManage/ExamViewListDetail', query: { bizId: jumpModuleId, bizType: 2401 } })
      break
    case '1600':
      router.replace({ path: '/faceDetail', query: { faceId: jumpModuleId } })
      break
    case '1700':
      router.replace({ path: '/signDetail', query: { trainConfirmId: jumpModuleId } })
      break
    case '1800':
      router.replace({ path: '/teamStudyDetail', query: { id: jumpModuleId, studyType: 1, } })
      break
  }
}
